// extracted by mini-css-extract-plugin
export default {"ClientDetail":"ClientDetail_ClientDetail__3rWF7","tableResponsive":"ClientDetail_tableResponsive__K2P8l"};